export type BankInstitutionStatusDto = {
  name: string;
  value: string;
  tone: string;
};

export type BankInstitutionDto = {
  uuid: string;
  shortName: string;
  legalName: string;
  status: BankInstitutionStatusDto;
  createdAt?: string;
  updatedAt?: string;
};

export type BankInstitutionRequest = {
  shortName: string;
  legalName: string;
};

export type BankInstitutionListQuery = {
  page?: number;
  size?: number;
  shortName?: string;
  legalName?: string;
  statusUuids?: readonly string[];
  sortBy?: string;
  order?: 'asc' | 'desc';
};

export type BankInstitutionListResult = {
  items: BankInstitutionDto[];
  total: number;
};

export type BankInstitutionFilterStatus = {
  uuid: string;
  name: string;
};

export type BankInstitutionFilterSelects = {
  statuses: BankInstitutionFilterStatus[];
};

export type BankInstitutionDownload = {
  blob: Blob;
  filename: string;
};

export const BANK_INSTITUTION_SHORT_NAME_MAX = 100;
export const BANK_INSTITUTION_LEGAL_NAME_MAX = 255;
